module.exports = __webpack_public_path__ + "static/media/Portrait-10197.cbb4b63c.jpg";